<template>
  <div class="pwa-role-select">
    <div class="pwa-role-select-shadow" @click="close"></div>
    <div class="pwa-role-select-main">
      <a href="javascript:;" class="main-close" @click="close"></a>
      <p class="main-title">{{ letter.chooseRoleGetGift }}</p>
      <div class="main-select">
        <SelectGroup icon="selectvh" rightSpan="53px" class="row-item mb15" v-model="serverId" @change="changeServer">
          <template slot="option">
            <option value="0" disabled>
              {{ letter.creatework_serverHolder }}
            </option>
            <optgroup :label="letter.yourServer">
              <option v-for="item in awardServerHistoryList" :key="item.id" :value="item.id">
                {{ item.sname }}
              </option>
            </optgroup>
            <optgroup :label="letter.allServer">
              <option v-for="item in awardServerList" :key="item.id" :value="item.id">
                {{ item.sname }}
              </option>
            </optgroup>
          </template>
          <template slot="ico">
            <em class="ico"></em>
          </template>
        </SelectGroup>
        <Select icon="selectvh" rightSpan="53px" class="row-item role-select mb15" v-model="roleId">
          <template slot="option">
            <option value="-1" disabled>
              {{ letter.selectRoleName }}
            </option>
            <option v-for="item in awardRoleList" :key="item.roleId" :value="item.roleId">
              {{ item.roleName }}
            </option>
          </template>
          <template slot="ico">
            <em class="ico"></em>
          </template>
        </Select>
      </div>
      <a class="main-bind" href="javascript:;" @click="getAward">
        {{ letter.claim }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  GET_AWARD_BASIC,
  GET_AWARD_SERVER_LIST,
  GET_AWARD_ROLE_LITS,
  GET_AWARD_BIND_ROLE,
  GET_AWARD_GIFT
} from '@store/officialTopup/award';
import { UPDATE_LOADING } from '@store/officialTopup/index';

export default {
  name: 'PwaRoleSelect',
  emits: ['close', 'showTipPopup'],
  data() {
    return {
      serverId: '0',
      roleId: '-1'
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      awardServerHistoryList: state => state.award.awardServerHistoryList,
      awardServerList: state => state.award.awardServerList,
      awardRoleList: state => state.award.awardRoleList
    })
  },
  methods: {
    close() {
      this.$emit('close');
    },
    showTipPopup(content) {
      this.$emit('showTipPopup', content);
    },
    getServerItemById(id) {
      return this.awardServerList?.find(item => item?.id === id);
    },
    getRoleItemById(roleId) {
      return this.awardRoleList?.find(item => item?.roleId === roleId);
    },
    async changeServer(value) {
      this.roleId = '-1';
      const res = await this.loadRoleList(value);
      if (+res?.result === 1 && res?.data?.length > 0) {
        this.roleId = res?.data[0]?.roleId || '-1';
      }
    },
    loadServerList() {
      this.$store.commit(UPDATE_LOADING, true);
      return this.$store.dispatch(GET_AWARD_SERVER_LIST).then(res => {
        this.$store.commit(UPDATE_LOADING, false);
        if (+res?.result !== 1) {
          this.showTipPopup(res?.msg ? `[${res.code}]${res.msg}` : res?.code);
          this.close();
          return;
        }
        return res;
      });
    },
    loadRoleList(value) {
      this.$store.commit(UPDATE_LOADING, true);
      const serverItem = this.getServerItemById(value);
      return this.$store
        .dispatch(GET_AWARD_ROLE_LITS, {
          server_id: serverItem?.sid
        })
        .then(res => {
          this.$store.commit(UPDATE_LOADING, false);
          if (+res?.result !== 1) {
            this.showTipPopup(res?.msg ? `[${res.code}]${res.msg}` : res?.code);
            this.close();
            return;
          }
          return res;
        });
    },
    loadBindRole() {
      const serverItem = this.getServerItemById(this.serverId);
      const roleItem = this.getRoleItemById(this.roleId);
      return this.$store.dispatch(GET_AWARD_BIND_ROLE, {
        server_id: serverItem?.sid,
        server_sid: this.serverId,
        server_name: encodeURIComponent(serverItem.sname),
        role_id: this.roleId,
        role_name: encodeURIComponent(roleItem?.roleName)
      });
    },
    loadGetAward() {
      return this.$store.dispatch(GET_AWARD_GIFT, {
        awardIndex: 0,
        groupIndex: 0
      });
    },
    async getAward() {
      if (this.serverId === '0') {
        this.showTipPopup(this.letter.creatework_serverHolder);
        this.close();
        return;
      }
      if (this.roleId === '-1') {
        this.showTipPopup(this.letter.selectRoleName);
        this.close();
        return;
      }

      try {
        this.$store.commit(UPDATE_LOADING, true);
        const bindRoleRes = await this.loadBindRole();
        if (+bindRoleRes?.result !== 1) {
          this.$store.commit(UPDATE_LOADING, false);
          const errorTip = bindRoleRes?.msg
            ? `[${bindRoleRes.code}]${bindRoleRes.msg}`
            : bindRoleRes?.code;
          this.showTipPopup(errorTip);
          this.close();
          window.webstorev3DataLayer.push({
            eventName: 'pwa_award',
            eventValue: {
              result: +bindRoleRes?.result,
              msg: errorTip
            }
          });
          return;
        }
        const getAwardRes = await this.loadGetAward();
        if (+getAwardRes?.result !== 1) {
          this.$store.commit(UPDATE_LOADING, false);
          const errorTip = getAwardRes?.code
            ? `[${getAwardRes?.code}]${this.letter['pwa' + getAwardRes?.code] || this.letter.pwaCommon}`
            : this.letter.pwaCommon;
          this.showTipPopup(errorTip);
          this.close();
          window.webstorev3DataLayer.push({
            eventName: 'pwa_award',
            eventValue: {
              result: +getAwardRes?.result,
              msg: errorTip
            }
          });
          return;
        }
        // 领取成功
        this.showTipPopup(this.letter.getGiftSuccess);
        this.close();
        window.webstorev3DataLayer.push({
          eventName: 'pwa_award',
          eventValue: {
            result: +getAwardRes?.result,
            msg: 'success'
          }
        });
        this.close();
      } catch (e) {
        console.error(e);
      }
      this.$store.commit(UPDATE_LOADING, false);
    }
  },
  created() {
    // 如果服务器列表加载过就不要加载了
    if (this.awardServerList?.length > 0) return;
    this.loadServerList();
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';
@import '@assets/scss/officialTopup/officialTopup.scss';

.pwa-role-select {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }

  &-main {
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    width: 720px;
    height: 500px;
    border-radius: 10px;
  }

  .main {
    &-close {
      position: absolute;
      right: 22px;
      top: 22px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url($commonImg + 'close.png');
      width: 28px;
      height: 28px;
    }

    &-title {
      margin: 64px auto 0px;
      padding: 0 44px;
      font-size: 36px;
      color: var(--popupTitleText, #333);
      text-align: center;
    }

    &-select {
      padding: 30px 64px 22px;
      box-sizing: border-box;

      .row-item {
        display: block;
        position: relative;
        box-sizing: border-box;
        margin: 0 auto 20px;
        width: 602px;
        height: 80px;
        background-size: cover;
        vertical-align: top;
        font-size: 24px;
        color: #333;
        border: 1px solid #d2d2d2;
        border-radius: 10px;

        ::v-deep .select {
          color: #333;
        }

        ::v-deep .ico {
          display: inline-block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: url($commonImg + 'role-ico.png') no-repeat;
          width: 22px;
          height: 13px;
        }
      }
    }

    &-bind {
      font-size: 36px;
      line-height: 70px;
      color: #fff;
      margin: 0px auto 0;
      background: $themeColor;
      width: 610px;
      height: 70px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      cursor: pointer;
    }
  }
}
</style>
